import axios from 'axios';
import { WEBSOCKET_URL } from '../helpers/constants';

export const getOnlineSession = async params => {
  const url = `${WEBSOCKET_URL}/online-connection`;

  const userIdsResponse = await axios.get(url, { params });
  const userIds = userIdsResponse.data;
  return userIds;
};
